import axios from 'axios'
let baseURL = '/api'
if (process.env.NODE_ENV === 'production') {
  baseURL = process.env.VUE_APP_API_BASE_URL;
} else {
  // 开发环境强制使用代理，避免CORS问题
  baseURL = '/api';
}
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  // withCredentials: true,
  baseURL: baseURL,
  timeout: 10000, // 增加请求超时时间
  // 所有请求都以Json形式传送
  // 会有预检请求，服务端需要正常通过OPTIONS请求
  headers: {
    'Content-Type': 'application/json',
  }
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    console.log('API错误响应:', error.response.status, error.response.data)
  } else if (error.request) {
    console.log('网络错误或CORS错误:', error.message)
    if (error.message.includes('CORS')) {
      console.error('CORS错误: 请检查后端API的Access-Control-Allow-Origin配置')
    }
  } else {
    console.log('请求配置错误:', error.message)
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  // 添加调试信息
  console.log('🚀 API请求:', config.baseURL + config.url, config.params);
  
  // const token = storage.get(ACCESS_TOKEN)
  // const url = new URL(process.env.VUE_APP_API_BASE_URL)
  // config.headers['APP-ZONE'] = url.hostname
  // // 如果 token 存在
  // // 让每个请求携带自定义 token 请根据实际情况自行修改
  // if (token) {
  //   config.headers['Access-Token'] = token
  // }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  return response.data
}, errorHandler)

export default request
